import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const CandidateRoute = ({ children }) => {
  const { token, user } = useSelector((s) => s.auth);
  if (!token || user?.role !== 'candidate') return <Navigate to="/login" replace />;
  return children;
};

export default CandidateRoute;
